module.exports = __webpack_public_path__ + "img/locationLarg.398f3bf1.png";